module.exports = __webpack_public_path__ + "img/VAR_GAS.0aac2f0f.png";